export default __webpack_public_path__ + "static/company-vive-076c953b8f71728367819e4e19163c51.png";